import React from "react";

function WhereEngrWork() {
  return (
    <section
      className="work-area-two work-bg"
      style={{
        backgroundImage: `url(${require("../../assets/img/bg/work_bg.jpg")})`,
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="section-title text-center mb-60 tg-heading-subheading animation-style3">
              <span className="sub-title tg-element-title">
                Meet Our Engineers
              </span>
              <h2 className="title tg-element-title">How Our Engineers Work</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div
              className="work-inner"
              style={{
                backgroundImage: `url(${require("../../assets/img/images/h3_work_img.jpg")})`,
              }}
            >
              <div className="work-tooltip-wrap">
                <div className="tooltip-item top">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item top">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
                <div className="tooltip-item">
                  <div className="tooltip-btn pulse">
                    <i className="fas fa-plus"></i>
                  </div>
                  <div className="tooltip-content">
                    <h2 className="title">Combustion Roof Vent</h2>
                    <p>
                      Suffered alteration in some a goody form, by injected
                      humor, or into the randomized word.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhereEngrWork;
